export type ServiceUnreadSection = 'messages' | 'quote' | 'status';

const SERVICE_UNREAD_SECTION_PRIORITY: ServiceUnreadSection[] = ['quote', 'messages', 'status'];

export const mapLegacyServiceUnreadTypeToSection = (
  type: string | null | undefined
): ServiceUnreadSection | null => {
  switch (type) {
    case 'message':
    case 'request_created':
      return 'messages';
    case 'quote_accepted':
      return 'quote';
    case 'status_change':
      return 'status';
    default:
      return null;
  }
};

export const normalizeServiceUnreadSections = (
  value: unknown,
  legacyType?: string | null
): ServiceUnreadSection[] => {
  const rawSections = Array.isArray(value) ? value : [];
  const normalized = rawSections
    .map((entry) => String(entry || '').trim())
    .filter(
      (entry): entry is ServiceUnreadSection =>
        entry === 'messages' || entry === 'quote' || entry === 'status'
    );
  const legacySection = mapLegacyServiceUnreadTypeToSection(legacyType || null);
  const merged = legacySection ? [...normalized, legacySection] : normalized;
  return Array.from(new Set(merged));
};

export const getPrimaryServiceUnreadSection = (
  sections: ServiceUnreadSection[]
): ServiceUnreadSection | null => {
  for (const section of SERVICE_UNREAD_SECTION_PRIORITY) {
    if (sections.includes(section)) {
      return section;
    }
  }
  return null;
};

export const getSecondaryServiceUnreadSection = (
  sections: ServiceUnreadSection[],
  primary: ServiceUnreadSection | null
): ServiceUnreadSection | null => {
  const candidates = primary ? sections.filter((section) => section !== primary) : sections;
  for (const section of SERVICE_UNREAD_SECTION_PRIORITY) {
    if (candidates.includes(section)) {
      return section;
    }
  }
  return null;
};

export const getServiceUnreadLegacyType = (
  sections: ServiceUnreadSection[]
): 'message' | 'quote_accepted' | 'status_change' | null => {
  const primary = getPrimaryServiceUnreadSection(sections);
  if (!primary) return null;
  if (primary === 'quote') return 'quote_accepted';
  if (primary === 'messages') return 'message';
  return 'status_change';
};
